import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressbarComponent } from './progressbar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ProgressbarComponent
    ],
    exports: [
        ProgressbarComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ]
})
export class ProgressBarModule { }
